import { connect } from 'react-redux';
import TimeSlots from './TimeSlots';

const mapStateToProps = (state) => {
  const { resources, units } = state;
  return {
    resources,
    units
  };
};

export default connect(mapStateToProps)(TimeSlots);



// WEBPACK FOOTER //
// ./src/containers/TimeSlots/index.js